import { useState, useEffect, useCallback, useRef } from 'react';
import { useDispatch } from 'dva';
import { useLocation, history } from 'umi';
import { Fab } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import qs from 'qs';
import IndexStyled from './IndexStyled';
import SearchGroup from './components/search_group/SearchGroup';
import TablePage from './components/table_page/TablePage';
import dayjs from 'dayjs';

const CrowdManage = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [isSearch, setIsSearch] = useState(false);
  const searchRef = useRef();
  const { query, pathname } = location;
  const {
    title,
    status,
    type = '2',
    updateStrategy,
    createName,
    pageNum = '1',
    pageSize = '10',
  } = query;

  const timestamp = dayjs().format('YYYY-MM-DD HH-mm-ss'); //筛选条件未变，也发请求

  const [columnCode, setColumnCode] = useState('GROUP_CREATEDATE');
  const [sort, setSort] = useState(true);

  // 查询事件处理
  const handleSearch = (newParam) => {
    setIsSearch(true);
    history.replace(
      `${pathname}?${qs.stringify({
        ...newParam,
        pageSize,
        pageNum: 1,
        time: timestamp,
      })}`,
    );
  };

  // 翻页事件处理
  const handlePageChange = (p) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...query,
        pageNum: p.pageNum,
        pageSize: p.pageSize,
      })}`,
    );
  };

  // 重置事件处理
  const handleRestClick = (rs) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...rs,
        pageSize: 10,
        pageNum: '1',
        time: timestamp,
      })}`,
    );
  };

  // 获取列表
  const fetchData = useCallback(() => {
    const values = {
      createName,
      status: status ? Number(status) : '',
      title,
      type,
      updateStrategy: Number(updateStrategy),
      sort: sort ? 'DESC' : 'ASC',
      columnCode,
      pageNum: Number(pageNum),
      pageSize: Number(pageSize),
    };
    if (isSearch) {
      window.NE_DAWN.trigger(searchRef.current, {
        event: '_ec', // 事件名
        params: { ...values }, // 事件公参
      });
    }
    setIsSearch(false);
    dispatch({
      type: 'crowdManage/getCrowdList',
      payload: {
        values,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    dispatch,
    sort,
    columnCode,
    createName,
    status,
    title,
    updateStrategy,
    pageNum,
    pageSize,
    timestamp,
    type,
  ]);

  // 发起请求
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    dispatch({
      type: 'crowdManage/queryGroupExportConfigList',
    });
  }, [dispatch]);

  // 创建人群
  function createClick() {
    history.push({
      pathname: '/profile/crowd_manage/crowd_create',
      query: {
        opt: 'create',
      },
    });
  }

  const handleImport = () => {
    history.push({
      pathname: '/profile/crowd_manage/crowd_import',
      query: {
        // opt: 'create',
      },
    });
  };
  return (
    <IndexStyled>
      <div
        id="export_id_mount_parent"
        data-log={JSON.stringify({
          oid: 'page_user_profile_management_list',
          isPage: true,
          params: {
            initUrl: window.location.origin + window.location.pathname,
          },
          events: ['_pv', '_pd'],
        })}
        className="crowd_content crowd_content_alert"
      >
        <div className="search_group">
          <SearchGroup
            searchRef={searchRef}
            query={query}
            handleSearch={(par) => handleSearch(par)}
            restClick={handleRestClick}
          ></SearchGroup>
        </div>
        <div className="create_button">
          <Fab
            data-log={JSON.stringify({
              oid: 'btn_user_profile_management_list_create',
              events: ['_ev', '_ec'],
              params: {
                initUrl: window.location.origin + window.location.pathname,
              },
            })}
            onClick={createClick}
            size="small"
            color="primary"
            aria-label="add"
            className="createBtn"
            variant="extended"
            sx={{ paddingRight: '11px', paddingLeft: '15px' }}
          >
            <AddIcon
              sx={{ width: '14px', height: '14px', marginRight: '8px' }}
            />
            创建人群
          </Fab>
          <Fab
            data-log={JSON.stringify({
              oid: 'btn_user_profile_management_list_import_external',
              events: ['_ev', '_ec'],
              params: {
                initUrl: window.location.origin + window.location.pathname,
              },
            })}
            onClick={handleImport}
            size="small"
            color="primary"
            aria-label="add"
            className="createBtn"
            variant="extended"
            sx={{ paddingRight: '11px', paddingLeft: '15px' }}
          >
            <AddIcon
              sx={{ width: '14px', height: '14px', marginRight: '8px' }}
            />
            导入外部人群
          </Fab>
        </div>
        <div className="table_page">
          <TablePage
            pagination={{
              pageNum,
              pageSize,
            }}
            setPageData={handlePageChange}
            setSortField={setColumnCode}
            setSort={setSort}
            sortField={columnCode}
          />
        </div>
      </div>
    </IndexStyled>
  );
};

export default CrowdManage;
